import webglManager from './molecules/webgl';

let _webgl = new webglManager();

export default class effectManager {
    constructor(){

        this.ease = CustomEase.create("custom", "M0,0,C0.126,0.382,0.282,0.674,0.44,0.822,0.632,1.002,0.818,1.001,1,1");

    }

    /* -----------------------------------------------

     -- panel

     -------------------------------------------------- */

    panelInit(){
        TweenLite.set($(".js__panel-square>*"), {y: '100%'});
    }
    panelMove(_target,$y,_type){

        let comp = function(){
            _target.parent().addClass("is-done");
        }
        switch (_type) {
            case 'hide': // --------------- hide --------------- //
                // motion
                TweenMax.staggerTo(_target, 0.68, {
                        y: $y,
                        opacity: 0,
                        ease: Expo.easeOut
                    }, .135
                );
            break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //
                // motion
                TweenMax.staggerTo(_target, 0.68, {
                        y: $y,
                        opacity: 1,
                        ease: Expo.easeOut
                    }, .135, comp
                );
            break; // --------------- show (end) --------------- //
        }

    }

    /* -----------------------------------------------

     -- text

     -------------------------------------------------- */

    splitTextInit(_text) {
        new SplitText(_text, {type:"words,chars"});
        if($('html.mobile')[0] || $('html.ie')[0] || $('html.edge')[0]) {
            for (let i = 0; i < _text.children().children().length; i++) {
                if (i % 2 == 0) {
                    _text.children().children().eq(i).addClass('odd');
                } else {
                    _text.children().children().eq(i).addClass('even');
                }
            }
        }
    }

    chaffleTextInit(_text) {
        Array.prototype.forEach.call(_text, function (el) {
            let chaffle = new Chaffle(el, {
                speed: 10,
                time: 10
            });
            el.addEventListener('mouseover', function () {
                chaffle.init();
            });
        });
        $('#l-developer__list').find('li').hover(function () {
        });
    }

    textMotion(_target,_type,_id) {
        let random = function (min, max) {
            return (Math.random() * (max - min)) + min;
        }

        switch (_type) {

            case 'hide': // --------------- hide --------------- //

                if($('html.mobile')[0] && _id !== 'l-main-copy' || $('html.ie')[0] && _id !== 'l-main-copy' || $('html.edge')[0] && _id !== 'l-main-copy'){
                    TweenMax.to(_target,.48, {
                        delay:0.05,
                        opacity:0,
                        ease: Power4.easeOut
                    });
                    TweenMax.to(_target.find('.odd'),.48, {
                        y: '-5px',
                        ease: Power4.easeOut
                    });
                    TweenMax.to(_target.find('.even'),.48, {
                        y: '5px',
                        ease: Power4.easeOut
                    });
                }else{
                    for (let i = 0; i < _target.length; i++) {
                        for (let j = 0; j < _target.eq(i).children().children().length; j++) {
                            TweenMax.to(_target.eq(i).children().children().eq(j), .88, {
                                opacity: 0,
                                x: random(-200, 200),
                                y: random(-200, 200),
                                z: random(-200, 200),
                                scale:random(0.1, 3),
                                rotationX: random(-360, 360),
                                rotationY: random(-360, 360),
                                rotationZ: random(-360, 360),
                                //'-webkit-filter':'blur(7px)',
                                //'filter':'blur(7px)',
                                ease: Circ.easeOut
                            });
                        }
                    }
                }

            break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //

                if($('html.mobile')[0] && _id !== 'l-main-copy' || $('html.ie')[0] && _id !== 'l-main-copy' || $('html.edge')[0] && _id !== 'l-main-copy'){
                    TweenMax.fromTo(_target.find('.odd'), .48, {
                        y: '-5px',
                    }, {
                        delay:0.2,
                        y: '0px',
                        ease: Power4.easeOut
                    });
                    TweenMax.fromTo(_target.find('.even'), .48, {
                        y: '5px',
                    }, {
                        delay:0.2,
                        y: '0px',
                        ease: Power4.easeOut
                    });
                    TweenMax.to(_target,.68, {
                        opacity:1,
                        ease: Power4.easeOut
                    });
                }else{
                    let $delay = .007;
                    //TweenLite.set(_target, { y: '0px', opacity:1 });
                    for (let i = 0; i < _target.length; i++) {
                        for (let j = 0; j < _target.eq(i).children().children().length; j++) {
                            TweenMax.fromTo(_target.eq(i).children().children().eq(j), .78, {
                                opacity: 0,
                                x: random(-250, 250),
                                y: random(-250, 250),
                                z: random(-250, 250),
                                scale: random(0.1, 4.5),
                                rotationX: random(-720, 720),
                                rotationY: random(-720, 720),
                                rotationZ: random(-720, 720),
                                //'-webkit-filter': 'blur(5px)',
                                //'filter': 'blur(5px)'
                            }, {
                                opacity: 1,
                                x: 0,
                                y: 0,
                                z: 0,
                                rotationX: 0,
                                rotationY: 0,
                                rotationZ: 0,
                                scale: 1,
                                //'-webkit-filter': 'blur(0px)',
                                //'filter': 'blur(0px)',
                                delay: j * $delay,
                                ease: Circ.easeOut
                            });
                        }
                    }
                }

            break; // --------------- show (end) --------------- //
        }
    }

    contentMotion(_target,_type,_id) {

        switch (_type) {

            case 'hide': // --------------- hide (start) --------------- //

                TweenMax.to(_target,.48, {
                    scale:.96,
                    y:'-10px',
                    opacity:0,
                    ease: Circ.easeOut
                });

                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //

                TweenMax.fromTo(_target, 1.08, {
                    y:'45px',
                    scale:1.05,
                    opacity:0,
                }, {
                    y:'0px',
                    scale:1,
                    delay:0.3,
                    opacity:1,
                    ease: Circ.easeOut
                });

                break; // --------------- show (end) --------------- //
        }
    }

    contentMotionSP(_target,_type) {

        switch (_type) {

            case 'hide': // --------------- hide (start) --------------- //

                TweenMax.to(_target.find('.outline'), 1.08, {
                    opacity:0,
                    ease: Circ.easeOut
                });
                TweenMax.to(_target.find('.js__split-text').find('.odd'),.48, {
                    y: '-5px',
                    ease: Power4.easeOut
                });
                TweenMax.to(_target.find('.js__split-text').find('.even'),.48, {
                    y: '5px',
                    ease: Power4.easeOut
                });
                TweenMax.to(_target.find('.js__split-text'),.68, {
                    delay:0.05,
                    opacity:0,
                    ease: Power4.easeOut
                });
                TweenMax.to($('#c-changepanel'), .68, {
                    display: 'none',
                    opacity: 0,
                    ease: Circ.easeOut
                });
                TweenMax.to(_target.find('.js__content-fade'), .48, {
                    scale:.96,
                    y:'-10px',
                    opacity:0,
                    ease: Circ.easeOut
                });

                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //

                TweenLite.set([_target.find('.outline'),_target.find('.js__split-text')], {
                    opacity:0,
                });
                TweenLite.set(_target.find('.js__content-fade'), {
                    y:'45px',
                    scale:1.05,
                    opacity:0
                });
                TweenMax.to(_target.find('.outline'), 1.08, {
                    delay:0.4,
                    opacity:1,
                    ease: Circ.easeOut,
                    onComplete:function(){
                        TweenMax.fromTo(_target.find('.js__split-text').find('.odd'), .48, {
                            y: '-5px',
                        }, {
                            y: '0px',
                            ease: Power4.easeOut
                        });　　　
                        TweenMax.fromTo(_target.find('.js__split-text').find('.even'), .48, {
                            y: '5px',
                        }, {
                            y: '0px',
                            ease: Power4.easeOut
                        });
                        TweenMax.to(_target.find('.js__split-text'),.68, {
                            opacity:1,
                            ease: Power4.easeOut
                        });
                        TweenMax.to($('#c-changepanel'), 1.98, {
                            delay: 0.3,
                            display: 'block',
                            opacity: 1,
                            ease: Circ.easeOut
                        });
                        TweenMax.to(_target.find('.js__content-fade'), .88, {
                            y: '0px',
                            scale: 1,
                            delay: 0.6,
                            opacity: 1,
                            ease: Circ.easeOut
                        });
                    }
                });

                break; // --------------- show (end) --------------- //
        }
    }

    /* -----------------------------------------------

     -- development

     -------------------------------------------------- */

    developmentMotion(_status,_target,_type) {

        let _titleEn = $('.l-development__title .en');
        let _titleJp = $('.l-development__title .jp');
        let _list = $('.l-development__list');
        let _bg = $('#l-development .bg');

        switch (_type) {
            case 'hide': // --------------- hide --------------- //

                // motion
                TweenMax.to([_titleEn,_titleJp,_list], .78,{
                    opacity: 0,
                    scale:1.1,
                    ease: Expo.easeOut
                });
                TweenMax.to(_bg, 1.48,{
                    opacity: 0,
                    scale:1.3,
                    rotation:-15,
                    transformOrigin:"50% 50%",
                    ease: Expo.easeOut
                });

                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //

                // set
                TweenLite.set([_titleEn,_titleJp,_list], { opacity: 0, scale:1.3, transformOrigin:"50% 50%" });
                TweenLite.set(_bg, { opacity: 0, rotation:-45, scale:1.5, transformOrigin:"50% 50%" });

                // motion
                TweenMax.to(_titleEn, .88,{
                    delay:0.6,
                    opacity: 1,
                    scale:1,
                    ease: Circ.easeOut
                });
                TweenMax.to(_titleJp, .88,{
                    delay:0.8,
                    opacity: 1,
                    scale:1,
                    ease: Circ.easeOut
                });
                TweenMax.to(_list, .88,{
                    delay:1.0,
                    opacity: 1,
                    scale:1,
                    ease: Circ.easeOut
                });
                TweenMax.to(_bg, 1.48,{
                    opacity: 1,
                    scale:1,
                    rotation:0,
                    ease: Expo.easeOut,
                    onComplete:function(){
                        _webgl.startstop(_status);
                    }
                });

                break; // --------------- show (end) --------------- //
        }

    }

    /* -----------------------------------------------

     -- developer

     -------------------------------------------------- */

    developerMotion(_status,_target,_type) {

        switch (_type) {
            case 'hide': // --------------- hide --------------- //

                let comp = function () {
                    _target.find('#l-developer__list li').removeClass('is-done');
                }

                $('#l-developer__contact').removeClass('is-done');
                TweenMax.to(_target.find(".js__text-fade").children().children(), .68,
                    {
                        opacity: 0,
                        ease: Circ.easeOut
                });
                TweenMax.to(_target.find('#l-developer__list li'), 1.18,
                    {
                        opacity: 0,
                        x: '0%',
                        ease: Expo.easeOut

                    }
                );
                TweenMax.to(_target.find(".bg"), 1.18,
                    {
                        opacity: 0,
                        x: '0%',
                        ease: Expo.easeOut

                    }
                );
                TweenMax.staggerTo(_target.find(".cover"), 1.18,
                    {
                        delay:0.13,
                        opacity: 0,
                        x: '-150px',
                        ease: Expo.easeOut
                    }, 0.13,comp);


            break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //

                // set
                TweenLite.set(_target.find(".js__text-fade").children().children(), { opacity: 0, x:'-10px' });
                _target.find('#l-developer__list li').removeClass('is-done');
                TweenLite.set(_target.find('#l-developer__list li'), { opacity: 1 });
                TweenLite.set([_target.find('.bg'),_target.find('.cover')], { opacity: 0, x:'-150px' });
                TweenLite.set(_target.find('.border'), { y: '100%' });

                // motion
                TweenMax.to(_target.find(".bg"), 1.18,
                    {
                        opacity: 1,
                        x: '0%',
                        ease: Expo.easeOut,
                        onComplete:function(){
                            _webgl.startstop(_status);
                        }

                    }
                );
                TweenMax.staggerTo(_target.find(".cover"), 1.18,
                    {
                        delay:0.13,
                        opacity: 1,
                        x: '0%',
                        ease: Expo.easeOut
                }, 0.13);
                TweenMax.staggerTo(_target.find(".border"), 2.18,
                    {
                        delay:0.13,
                        y: '0%',
                        ease: Expo.easeOut
                    }, 0.13);

                TweenMax.staggerTo(_target.find('#l-developer__list li'), 1,
                    {
                        delay:0.33,
                        className:"+=is-done"
                    }, 0.13);
                TweenMax.to($('#l-developer__contact'), 1,
                {
                    delay:0.47,
                    className:"+=is-done"
                });
                TweenMax.staggerTo(_target.find(".js__text-fade").children().children(), .68,
                {
                    delay:0.23,
                    opacity: 1,
                    x:'0px',
                    ease: Circ.easeOut
                }, 0.02);

                break; // --------------- show (end) --------------- //
        }

    }

    /* -----------------------------------------------

     -- contact

     -------------------------------------------------- */

    contactMotion(_status,_target,_type) {

        switch (_type) {
            case 'hide': // --------------- hide --------------- //

                TweenMax.to([_target.find(".js__text-fade").children().children(),_target.find(".c-btn__learn")], .68,
                    {
                        opacity: 0,
                        ease: Circ.easeOut
                    });
                TweenMax.to(_target.find(".bg"), .88,
                    {
                        opacity: 0,
                        ease: Expo.easeOut

                    }
                );


                break; // --------------- hide (end) --------------- //

            case 'show': // --------------- show (start) --------------- //

                // set
                TweenLite.set([_target.find(".js__text-fade").children().children(),_target.find(".c-btn__learn")], { opacity: 0, x:'-10px' });
                TweenLite.set(_target.find('.bg'), { opacity: 0 });

                // motion
                TweenMax.to(_target.find(".bg"), 1.18,
                    {
                        opacity: 1,
                        ease: Expo.easeOut,
                        onComplete:function(){
                            TweenMax.staggerTo(
                                    _target.find(".l-contact__list").eq(0).find(".js__text-fade").children().children(), .58,
                                {
                                    delay:0.43,
                                    opacity: 1,
                                    x:'0px',
                                    ease: Circ.easeOut
                                }, 0.02);
                            TweenMax.staggerTo(
                                    _target.find(".l-contact__list").eq(1).find(".js__text-fade").children().children(), .58,
                                {
                                    delay:0.43,
                                    opacity: 1,
                                    x:'0px',
                                    ease: Circ.easeOut
                                }, 0.02);
                            TweenMax.to(_target.find(".c-btn__learn"), .68,
                                {
                                    delay:0.63,
                                    opacity: 1,
                                    x:'0px',
                                    ease: Circ.easeOut,
                                    onComplete:function(){
                                        _webgl.startstop(_status);
                                    }
                                });
                        }
                    }
                );

                break; // --------------- show (end) --------------- //
        }

    }

    /* -----------------------------------------------

     -- news Text

     -------------------------------------------------- */

    newsText(_target,_type) {
        switch (_type) {
            case 'set': // --------------- hide --------------- //
                TweenLite.set($(_target).find(".js__tsc-text-object"),{
                    opacity: 0
                });
                TweenLite.set($(_target).find(".js__tsc-text-cover"),{
                    x:'-100%'
                });
            break; // --------------- hide (end) --------------- //
            case 'show': // --------------- hide --------------- //
                TweenMax.staggerTo($(_target).find(".js__tsc-text-object"), .68,{
                    delay: 0.9,
                    opacity: 1,
                    ease: this.ease,
                },0.15);
                TweenMax.staggerTo($(_target).find(".js__tsc-text-cover"), 1.08,{
                    delay: 0.4,
                    x:'100%',
                    ease: this.ease,
                },0.15,() =>{
                    $(_target).find(".js__tsc-text-cover").remove();
                });
            break; // --------------- hide (end) --------------- //
            case 'hide': // --------------- hide --------------- //

            break; // --------------- hide (end) --------------- //
        }
    }

    /* -----------------------------------------------

     -- news Image

     -------------------------------------------------- */

    newsImage(_target,_type) {
        switch (_type) {
            case 'set': // --------------- hide --------------- //
                //TweenLite.set($(_target).find(".js__tsc-image-object"),{ scale:1.5});
                break; // --------------- hide (end) --------------- //
            case 'show': // --------------- hide --------------- //
                TweenMax.staggerFromTo($(_target).find(".js__tsc-image-object"), .88,{
                    delay:0.2,
                    scale:1.4
                },{
                    scale:1,
                    ease: this.ease,
                },0.1);
                TweenMax.staggerTo($(_target).find(".js__tsc-image-cover"), 1.08,{
                    y:'-100%',
                    ease: this.ease,
                },0.1);
                break; // --------------- hide (end) --------------- //
            case 'hide': // --------------- hide --------------- //

                break; // --------------- hide (end) --------------- //
        }
    }

    /* -----------------------------------------------

     -- news Line

     -------------------------------------------------- */

    newsLine(_target,_type) {
        switch (_type) {
            case 'set': // --------------- hide --------------- //
                for( let n in _target ) {
                    if (_target[n].nodeType != 1) continue; // dom要素以外は処理止める
                    if($(_target[n]).hasClass('js__tsc-line-vertical')){
                        TweenLite.set($(_target[n]).find(".js__tsc-line-object"),{ x:'-100%'});
                    }else{
                        TweenLite.set($(_target[n]).find(".js__tsc-line-object"),{ y:'100%'});
                    }
                }
                break; // --------------- hide (end) --------------- //
            case 'show': // --------------- hide --------------- //
                TweenMax.staggerTo($(_target).find(".js__tsc-line-object"), .68,{
                    delay: 0.2,
                    x:'0%',
                    y:'0%',
                    ease: this.ease,
                },0.2);
                break; // --------------- hide (end) --------------- //
            case 'hide': // --------------- hide --------------- //

                break; // --------------- hide (end) --------------- //
        }
    }

    /* -----------------------------------------------

     -- share

     -------------------------------------------------- */

    share(_target,_type) {
        switch (_type) {
            case 'set': // --------------- hide --------------- //
                for( let n in _target ) {
                    if (_target[n].nodeType != 1) continue; // dom要素以外は処理止める
                    TweenLite.set($(_target).find(".js__tsc-share-child"),{ opacity:0});
                    TweenLite.set($(_target).find(".js__tsc-share-child svg"),{x:-15});
                }
                break; // --------------- hide (end) --------------- //
            case 'show': // --------------- hide --------------- //
                setTimeout(()=> {
                    $(_target).find(".js__tsc-share-parent").addClass('is-done');
                }, '16e2');
                TweenMax.staggerTo($(_target).find(".js__tsc-share-child"), .48,{
                    delay: 1.6,
                    opacity:1,
                    ease: this.ease,
                },0.1);
                TweenMax.staggerTo($(_target).find(".js__tsc-share-child svg"), .48,{
                    delay: 1.6,
                    x: 0,
                    ease: this.ease,
                },0.1);
                break; // --------------- hide (end) --------------- //
            case 'hide': // --------------- hide --------------- //

                break; // --------------- hide (end) --------------- //
        }
    }

}